import * as R from 'ramda'

export const statementCarrier: {
  [key: string]: string;
} = {
  COUNTRY_WIDE: 'Country Wide',
  PROGRESSIVE: 'Progressive',
  DJL: 'DJL'
}

export const statementCarrierKeys = R.keys(statementCarrier)
export const statementCarrierValues = R.values(statementCarrier)

export const statementTableHeaderName: {
  [key: string]: string;
} = {
  co: 'CO',
  pfx: 'PFX',
  number: 'Number',
  sfx: 'SFX',
  payPlan: 'Pay Plan',
  polStat: 'POL Stat',
  insuredName: 'Insured Name',
  commDueCancel: 'Comm Due Cancel',
  commissionPaid: 'Commission Paid/Withheld',
  totalCommission: 'Total Commission',
  paymentsReceived: 'Payments Received/Adjustments',
  totalCommissionDUe: 'Total Commission Due',
  totalWrittenPremium: 'Total Written Premium',
  netCommissionDueAgent: 'Net Commission Due Agent',
  commissionDueOnPayments: 'Commission Due on Payments/Adjustments',
  commissionDueDownPayment: 'Commission Due Down Payment',
  policyNumber: 'Policy Nbr',
  term: 'Term',
  pd: 'PD',
  mktLvl: 'Mkt Lvl',
  agtPfx: 'Agt Pfx',
  tranCode: 'Tran Code',
  tranDate: 'Tran Date',
  grossPremium: 'Gross Premium',
  downPmtCollected: 'Down Pmt Collected',
  downPmtSubmitted: 'Down Pmt Submitted',
  amountDueCoFromAgent: 'Amount Due Co. from Agent',
  commPercentage: 'Comm %',
  grossComm: 'Gross Comm',
  netBalanceDueAgt: 'Net Balance Due AGT',
  agentName: 'Agent Name',
  amountToBeBilledByCompany: 'Amount to be Billed by Company',
  polSrc: 'Pol Src',
  rnwCnt: 'Rnw Cnt',
  clientName: 'Client Name',
  polTypeCode: 'Pol Type Code',
  itemNumber: 'Item Nbr',
  effectiveDate: 'Effective Date',
  transCode: 'Trans Code',
  transAmt: 'Trans Amt',
  comAmt: 'Comm Amt',
  payment: 'Payment',
  policyEffectiveDate: 'Policy Effective Date',
  policyExpirationDate: 'Policy Expiration Date',
  prod: 'Prod',
  agtPre: 'Agt Pre',
  downPaymentCollected: 'Down Payment Collected',
  downPaymentSubmitted: 'Down Payment Submitted',
  billedAmount: 'Billed Amount',
  agencyDue: 'Agency Due',
  comm: 'Comm',
  netDueAgent: 'Net Due Agent',
  prodName: 'Prod Name',
  agentCode: 'Agent Code',
  monthEnd: 'Month End',
  renewalCount: 'Renewal Count'
}

export const statementTableHeaderNameKeys = R.keys(statementTableHeaderName)
export const statementTableHeaderNameValues = R.values(statementTableHeaderName)
